import {showCommunicationError, showSuccess} from 'helpers/alerts';
import i18n from 'i18n/i18n';
import {observable} from 'mobx';
import {
  ApiUserAuthChangepasswordwithtokenPostRequest,
  ApiUserAuthSendpasswordtokenPostRequest,
  CollectorAdministratorCreateDto,
  Int32GenericApiResponse,
  LoginLocalRequest,
  RegisterUserLocalRequest,
  RegistrationResult,
  SuccessfullApiResponse,
} from '../../../../../PRMGApiClient';
import {Api} from '../../../../../PRMGApiClient/ApiClient';

export class AuthState {
  loginEmail = '';
  signUpEmail = '';
  resetPasswordEmail = '';

  @observable
  signUpStatusCode: number = 0;

  login(payload: LoginLocalRequest): Promise<RegistrationResult> {
    this.loginEmail = payload.email;
    return Api.UserAuth.apiUserAuthLoginPost({
      loginLocalRequest: payload,
    });
  }

  logout(): Promise<SuccessfullApiResponse | void> {
    return Api.UserAuth.apiUserAuthLogoutPost();
  }

  createCollectorAdministrator(payload: CollectorAdministratorCreateDto): Promise<Int32GenericApiResponse> {
    return Api.CollectorAdministrator.apiCollectorAdministratorAddPost({
      collectorAdministratorCreateDto: payload,
    });
  }

  reset(payload: ApiUserAuthChangepasswordwithtokenPostRequest): Promise<SuccessfullApiResponse> {
    return Api.UserAuth.apiUserAuthChangepasswordwithtokenPost(payload);
  }

  sendResetLink(payload: ApiUserAuthSendpasswordtokenPostRequest): Promise<SuccessfullApiResponse> {
    this.resetPasswordEmail = payload.email ?? '';
    return Api.UserAuth.apiUserAuthSendpasswordtokenPost(payload);
  }

  signUp(payload: RegisterUserLocalRequest): Promise<RegistrationResult> {
    return Api.UserAuth.apiUserAuthRegisterPost({
      registerUserLocalRequest: payload,
    });
  }

  resendActivationLink(): Promise<void> {
    return Api.UserAuth.apiUserAuthResendActivationLinkGet({email: this.resetPasswordEmail})
      .then(() => showSuccess(i18n.t('Activation link sent')))
      .catch(showCommunicationError);
  }
}
